export default __webpack_public_path__ + "static/dylan-moses-transblue-5568e603f964e792ff537426e1e3b91d.png";